import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CryptoJS from "crypto-js";

// import { AppConstant } from "../../config/AppConstants.js";
import { handleApiResponse } from "../../hooks/notificationHelper.js";
import { useUser } from "../../context/UserContext.jsx";
import { LoginWithPassword } from "../apiUtils.jsx";
//import LoginUI from "./LoginUI.jsx";
import LoginUI from "./LoginUI.jsx";
import { getAccessToken, getLoginId, setAccessToken, setFirstname, setGuId, setLastname, setLoginId, setRefreshToken, setEmailID, getGuId, setMakeInvitations, setSSOLogin } from "../../utils/SecurityService.js";
import { CheckUserVehicle_api, FetchCompaniesByEmail_api, ForgotPassword_api, ManualLogin_api, Profile_api, RedirectToUrl_api, Register_api } from "./LoginAPI.js";
import { AppConstant } from "../../config/AppConstants.js";
import { useTranslation } from 'react-i18next';
import { app } from "@microsoft/teams-js";
import GTM from "react-gtm-module";
import { EMAIL_PATTERN } from "../../utils/CommonUtils.js";

function LoginEvent() {
    const { t } = useTranslation("common");
    const [isLoading, setIsLoading] = useState(false);
    const [ClientId, setClientId] = useState(AppConstant.DEFAULT_CLIENT_ID);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [error, setError] = useState(null);
    const [fieldError, setFieldError] = useState({});
    const history = useHistory();

    const { setUser } = useUser();
    // Validation patterns rules
    const emailPattern = EMAIL_PATTERN;
    const nameLetterRule = /^[A-Za-zÀ-ÿ ]+$/;
    const passwordletters = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/;

    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [loadingCompanies] = useState(false);
    const [loginMethods, setLoginMethods] = useState([]);
    const [loadingLoginMethods, setLoadingLoginMethods] = useState(false);
    const [selectedLoginMethod, setSelectedLoginMethod] = useState(null);

    const PasswordT = CryptoJS.MD5(password).toString(CryptoJS.enc.Hex);
    const PasswordN = CryptoJS.SHA512(password).toString(CryptoJS.Hex);

    const [showManualLogin, setShowManualLogin] = useState(false);
    const [showForgotPasswordMessage, setShowForgotPasswordMessage] = useState(false);
    const [forgotPasswordMessage, setForgotPasswordMessage] = useState("");
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);

    const [isNewUser, setIsNewUser] = useState(null);

    const [notification, setNotification] = useState(null);

    const setEmailApiError = (message) => {
        const errorMessage = message || t("email_not_valid");
        setFieldError({ field: "", message: "" });
        setError(errorMessage);
    };

    const isEmailRelatedError = (message = "") => {
        const normalizedMessage = String(message).toLowerCase();
        return normalizedMessage.includes("email");
    };

    const getLoginDiscoveryPayload = (response) => {
        const data = response?.Data || response?.data || {};
        const records = data?.Records || data?.records || {};
        const rawCompanies = records?.Companies || records?.companies || [];
        const rawLoginMethods = records?.LoginMethods || records?.loginMethods || [];

        const companies = rawCompanies.map((company) => ({
            ...company,
            id: company?.id ?? company?.Id ?? company?.CompanyId ?? company?.CompanyID ?? "",
            CompanyName: company?.CompanyName || company?.companyName || company?.Name || company?.name || "",
        }));

        const loginMethods = rawLoginMethods.map((method) => ({
            ...method,
            ssotype: String(
                method?.ssotype ??
                method?.SSOType ??
                method?.SsoType ??
                method?.SelectedMethod ??
                method?.selectedMethod ??
                method?.Type ??
                method?.type ??
                ""
            ).toLowerCase(),
            Name: method?.Name || method?.name || method?.DisplayName || method?.displayName || "",
            companyId: String(
                method?.companyId ??
                method?.CompanyId ??
                method?.companyID ??
                method?.CompanyID ??
                ""
            ),
        }));

        return {
            responseCode: data?.ResponseCode ?? data?.responseCode,
            companies,
            loginMethods,
            isNewUser: records?.IsNewUser ?? records?.isNewUser,
        };
    };

    useEffect(() => {
        GTM.initialize({ gtmId: "GTM-WBZXCD8" });
        GTM.dataLayer({
            dataLayer: {
                event: "page_view",
                page_path: window.location.pathname,
                page_title: "Login",
            },
        });
    }, []);


    useEffect(() => {
        document.title = `${t("react_web_login")} | Ronspot`;
      }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (window.$?.fn?.validate) {
            window.$(".login-form").validate();
        }
    }, []);

    useEffect(() => {
        setShowManualLogin(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCompany]);

    const ToCheckVehicle = async (uid) => {
        try {
            const requestParams = {
                GuId: uid || getGuId(),
            };
            const response = await CheckUserVehicle_api(requestParams);
            
            console.log("Vehicle check params:", requestParams);
            console.log("Vehicle check response:", response);

            if (response?.Data?.ResponseCode !== 200) {
                throw new Error("Vehicle verification failed");
            }

            const showVehiclePopup = Number(response?.Data?.Records?.ShowVehiclePopup ?? 0);
            const parkingZonesAssigned = Number(response?.Data?.Records?.ParkingZonesAssigned ?? 0);

            if (parkingZonesAssigned === 1 && showVehiclePopup === 1) {
                sessionStorage.setItem("vehiclenotavailable", "true");
            } else {
                sessionStorage.removeItem("vehiclenotavailable");
            }
        } catch (error) {
            console.error("Vehicle check error:", error);
            throw error;
        }
    };

    const redirectToHome = async () => {
        try {
            await ToCheckVehicle();
        } catch (error) {
            console.error("ToCheckVehicle API failed:", error);
        } finally {
            history.replace("/calendar");
        }
    };

    const hydrateSessionFromProfile = (records = {}) => {
        if (records?.FirstName) setFirstname(records.FirstName);
        if (records?.LastName) setLastname(records.LastName);
        if (records?.PrimaryEmail) setEmailID(records.PrimaryEmail);
        if (records?.MakeInvitations !== undefined && records?.MakeInvitations !== null) setMakeInvitations(records.MakeInvitations);

        const loginId = records?.Id || records?.id;
        if (loginId) setLoginId(loginId);

        if (records?.Notifications !== undefined && records?.Notifications !== null) {
            sessionStorage.setItem("Notifications", records.Notifications);
        }

        setUser({
            firstName: records?.FirstName || "",
            lastName: records?.LastName || "",
        });
    };

    const handleSingleLoginMethod = async (methods = []) => {
        if (!Array.isArray(methods) || methods.length !== 1) {
            return false;
        }

        const singleMethod = methods[0];
        setSelectedLoginMethod(singleMethod);

        if (singleMethod?.ssotype === "manual") {
            setShowManualLogin(true);
            return true;
        }

        await handleRedirect(singleMethod);
        return true;
    };

    const shouldHideSingleSsoMethodList = (methods = []) => (
        Array.isArray(methods) &&
        methods.length === 1 &&
        methods[0]?.ssotype !== "manual"
    );

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setFieldError({ field: "", message: "" });
        //sessionStorage.clear();
        //localStorage.clear();
        let data;

        if (!email || email.trim() === "") {
            setFieldError({
                field: "email",
                message: t("enter_email_add")
            });
            setError(t("enter_email_add"));
            return;
        }
        
        if (!isTermsAccepted) {
            setError(t("please_accept_terms_conditions_proceed"));
            return;
        }
        else { setError(null); }

        if (!emailPattern.test(email)) {
            setFieldError({
                field: "email",
                message: t("email_not_valid")
            });
            setError(t("email_not_valid"));
            return;
        }

        try {
            // Register New User
            if (isNewUser === 1 && showManualLogin) {

                if (!isTermsAccepted) {
                    setError(t("please_accept_terms_conditions_proceed"));
                    return;
                }

                if (!email || email.trim() === "") {
                    setError(t("enter_email_add"));
                    return;
                }

                if (!emailPattern.test(email)) {
                    setError(t("email_not_valid"));
                    return;
                }

                if (!firstName || firstName.trim() === "") {
                    setFieldError({
                        field: "firstName",
                        message: t("pleaseenter_firstname")
                    });
                    return;
                }
                else if (!nameLetterRule.test(firstName)) {
                    setFieldError({
                        field: "firstName",
                        message: t("not_allow_char")
                    });
                    return;
                }

                if (!lastName || lastName.trim() === "") {
                    setFieldError({
                        field: "lastName",
                        message: t("pleaseenter_lastname")
                    });
                    return;
                }
                else if (!nameLetterRule.test(lastName)) {
                    setFieldError({
                        field: "lastName",
                        message: t("not_allow_char")
                    });
                    return;
                }

                if (!password || password.trim() === "") {
                    setFieldError({
                        field: "password",
                        message: t("react_please_enter_password")
                    });
                    return;
                }
                /* else if (password.length < 10) {
                    setFieldError({
                        field: "password",
                        message: t("react_minimum_length_password")
                    });
                    return;
                } */
                else if (!passwordletters.test(password)) {
                    setFieldError({
                        field: "password",
                        message:
                            t("react_password_requirements")
                    });
                    return;
                }

                // ✅ clear error if all valid
                setFieldError({ field: "", message: "" });

                // When the validation API returns exactly one LoginMethods entry,
                // there is no company list to select from, so fall back to the
                // CompanyID carried by that single method for the register call.
                const isSingleLoginMethod = Array.isArray(loginMethods) && loginMethods.length === 1;

                const requestParams = {
                    firstName,
                    lastName,
                    emailId: email,
                    password,
                    companyId: selectedCompany?.id
                        || (isSingleLoginMethod ? selectedLoginMethod?.companyId : "")
                        || "",
                    ClientId,
                    RequestFrom: AppConstant.RequestFrom,
                    UniqueId: AppConstant.RegisterUserUniqueId
                };

                const response = await Register_api(requestParams);

                if (response?.Data?.ResponseCode === 200) {
                    history.push("/RegisterSuccess");
                } else {
                    const errorMessage = response?.Data?.ErrorMessage;
                    if (isEmailRelatedError(errorMessage)) {
                        setEmailApiError(errorMessage);
                    } else {
                        setError(errorMessage);
                    }
                }
            }

            // Manual Login for Existing User without SSO setup
            else if (showManualLogin) {
                if (!password || password.trim() === "") {
                    setFieldError({
                        field: "password",
                        message: t("react_please_enter_password")
                    });
                    return;
                }
                /* else if (password.length < 10) {
                    setFieldError({
                        field: "password",
                        message: t("react_minimum_length_password")
                    });
                    return;
                } */
                else if (!passwordletters.test(password)) {
                    setFieldError({
                        field: "password",
                        message:
                            t("react_password_requirements")
                    });
                    return;
                }

                // ✅ clear error if all valid
                setFieldError({ field: "", message: "" });

                const requestParams = {
                    ClientId,
                    PrimaryEmail: email,
                    Password: password
                };
                const data = await ManualLogin_api(requestParams);
                console.log("ManualLogin_api response:", data);
                if (!data) {
                    const errorMessage = data?.Data?.ErrorMessage;
                    if (isEmailRelatedError(errorMessage)) {
                        setEmailApiError(errorMessage);
                    } else {
                        setError(errorMessage);
                    }
                    return;
                }
                const { Records, ResponseCode, ErrorMessage } = data.Data;
                if (ResponseCode !== 200) {
                    if (isEmailRelatedError(ErrorMessage)) {
                        setEmailApiError(ErrorMessage);
                    } else {
                        setError(ErrorMessage || "Login failed");
                    }
                    return;
                }
                // User Context
                setUser({
                    firstName: Records.FirstName,
                    lastName: Records.LastName,
                });
                // set in sessionStorage
                sessionStorage.setItem("Notifications", Records.Notifications);
                setSSOLogin(0);
                setAccessToken(Records.AccessToken);
                setRefreshToken(Records.RefreshToken);
                setGuId(Records.guid);
                setLoginId(Records.id);
                setFirstname(Records.FirstName);
                setLastname(Records.LastName);
                setEmailID(Records.PrimaryEmail);
                if (Records?.MakeInvitations !== undefined && Records?.MakeInvitations !== null) setMakeInvitations(Records.MakeInvitations);
                console.log("Login Successful — Tokens Saved");
                const guid = getGuId();

                if (!guid || guid.trim() === "") {
                    return;
                }
                await redirectToHome();
            }
            // SSO Login Flow - Fetch Companies and Login Methods
            else {
                console.log("Debug Mode Login with Email:", email, "and Company:", selectedCompany);

                const reqParams = {
                    ClientId,
                    PrimaryEmail: email,
                    CompanyId: selectedCompany ? selectedCompany.id : "",
                };
                console.log("FetchCompaniesByEmail -reqParams-", reqParams);

                FetchCompaniesByEmail_api(reqParams)
                    .then(async (response) => {
                        const { responseCode, companies: fetchedCompanies, loginMethods: fetchedLoginMethods, isNewUser: fetchedIsNewUser } =
                            getLoginDiscoveryPayload(response);
                        console.log("FetchCompaniesByEmail response-->", response);
                        if (responseCode === 200) {
                            console.log("LoginMethods fetched:", fetchedLoginMethods);
                            setCompanies(fetchedCompanies);
                            setIsNewUser(fetchedIsNewUser);

                            if (!shouldHideSingleSsoMethodList(fetchedLoginMethods)) {
                                setLoginMethods(fetchedLoginMethods);
                            }

                            if (await handleSingleLoginMethod(fetchedLoginMethods)) {
                                return;
                            }

                            if (fetchedCompanies.length === 1 && fetchedLoginMethods.length === 0) {
                                setSelectedCompany(fetchedCompanies[0]);
                            }
                        }
                        else {
                            const errorMessage = response?.Data?.ErrorMessage;
                            if (isEmailRelatedError(errorMessage)) {
                                setEmailApiError(errorMessage);
                            } else {
                                setError(errorMessage);
                            }
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }

        } catch (err) {
            console.error("Login Error:", err);
            setError("Login failed.");
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {

        if (!selectedCompany) return;

        setLoadingLoginMethods(true);
        setLoginMethods([]);
        console.log("Selected company changed:", selectedCompany);
        const reqParams = {
            ClientId,
            PrimaryEmail: email,
            CompanyId: selectedCompany ? selectedCompany.id : "",
        };

        FetchCompaniesByEmail_api(reqParams)
            .then(async (response) => {
                console.log("Login methods response:", response);
                const { responseCode, loginMethods: fetchedLoginMethods } =
                    getLoginDiscoveryPayload(response);

                if (responseCode === 200) {
                    if (!shouldHideSingleSsoMethodList(fetchedLoginMethods)) {
                        setLoginMethods(fetchedLoginMethods);
                    }
                    await handleSingleLoginMethod(fetchedLoginMethods);
                }
            })
            .catch((err) => {
                console.error("Login methods error:", err);
            })
            .finally(() => setLoadingLoginMethods(false));

    }, [selectedCompany]);

    const handleEmailChange = (value) => {
        setEmail(value);
        setFieldError({ field: "", message: "" });
        setPassword("");

        // ✅ RESET EVERYTHING HERE (parent owns state)
        setSelectedCompany(null);
        setCompanies([]);
        setLoginMethods([]);
        setShowManualLogin(false);
        setShowForgotPasswordMessage(false);
        setForgotPasswordMessage("");
        setError(null);
        setSelectedLoginMethod(null)
    };
    const handleForgotPassword = async () => {
        setError(null);

        if (!email || email.trim() === "") {
            setError(t("enter_email_add"));
            return;
        }

        if (!emailPattern.test(email)) {
            setError(t("email_not_valid"));
            return;
        }

        try {
            const requestParams = {
                ClientId,
                PrimaryEmail: email,
                RequestFrom:AppConstant.RequestFrom
            };

            const response = await ForgotPassword_api(requestParams);
            const responseMessage =
                response?.Data?.ErrorMessage ||
                response?.Data?.ResponseMessage ||
                t("forgot_password_mail");

            setForgotPasswordMessage(responseMessage);
            setShowForgotPasswordMessage(true);

            setTimeout(() => {
                setShowForgotPasswordMessage(false);
                setForgotPasswordMessage("");
                setEmail("");
                setPassword("");
                setShowManualLogin(false);
                setSelectedCompany(null);
                setCompanies([]);
                setLoginMethods([]);
                setSelectedLoginMethod(null);
                setIsNewUser(null);
                setError(null);
            }, 5000);
        } catch (err) {
            console.error("Forgot password error:", err);
            setError(t("something_went_wrong"));
        }
    };
    const handleRedirect = async (loginMethodParam) => {
        try {
            if (!isTermsAccepted) {
                setError(t("please_accept_terms_conditions_proceed"));
                return;
            }
            else { setError(null); }
            const method = loginMethodParam || selectedLoginMethod;

            console.log("Selected login method:", method);

            if (!method) {
                setError("Please select a login method");
                return;
            }

            if (!email || email.trim() === "") { setError("Please enter an email address"); return; }
            if (!emailPattern.test(email)) {
                setError("Please provide a valid email address");
                return;
            }
            //console.log("selectedCompany-->", selectedCompany,selectedCompany.id)
            const redirectCompanyId =
                method?.companyId ||
                (selectedCompany ? selectedCompany?.id : "") ||
                "";
            console.log("Redirecting with Company ID:", redirectCompanyId);
            const requestParams = {
                CompanyId: redirectCompanyId,
                Isnewuser: isNewUser ?? 0,
                Email: email,
                RequestFrom: AppConstant.RequestFrom, //Never change this value as it's being used in API to identify the request is coming from React App or not and building URL accordingly for Staging/ LOCAL
                ClientId:ClientId,                   // ✅ required
                SelectedMethod: method?.ssotype || "microsoft"
            };

            console.log("Redirect API request:", requestParams);

            const response = await RedirectToUrl_api(requestParams);

            if (response?.Data?.ResponseCode === 200) {
                const redirectUrl = response?.Data?.Records?.[0]?.url;

                if (redirectUrl) {
                    window.location.href = redirectUrl;
                    setSSOLogin(1);
                } else {
                    setError("Redirect URL not found");
                }
            } else {
                setError(response?.Data?.ErrorMessage || "Redirect failed");
            }

        } catch (err) {
            console.error("Redirect error:", err);
            setError("Something went wrong");
        }
    };

    useEffect(() => {

        const existingToken = getAccessToken();
        const existingGuid = getGuId();
        const existingLoginId = getLoginId();

        const params = new URLSearchParams(window.location.search);
        const atoken = params.get("atoken");
        const rtoken = params.get("rtoken");
        const uid = params.get("uid");
        const IsQuerystringParaAvailable = [atoken, rtoken, uid].every((param) => param && param.trim().length > 0);

        const handleSsoCallback = async () => {
            if (!IsQuerystringParaAvailable) return;

            try {
                setIsLoading(true);
                setError(null);
                console.log("SSO Login Success");

                setSSOLogin(1);
                setAccessToken(atoken);
                setRefreshToken(rtoken);
                setGuId(uid);

                await fetchProfileData(uid);

                // Clean URL only after we've persisted the callback session
                window.history.replaceState({}, document.title, window.location.pathname);
            } catch (error) {
                console.error("SSO callback handling failed:", error);
                setError("Unable to complete SSO login.");
                setIsLoading(false);
            }
        };

        if (IsQuerystringParaAvailable) {
            handleSsoCallback();
            return;
        }

        if (existingToken && existingGuid && existingLoginId) {
            redirectToHome();
        }
        /* else {
            window.location.href = "/"; // else goto-login new
        } */
    }, [history]);

    const fetchProfileData = async (uid) => {
        try {
            const requestParams = {
                GuId: uid, // or UserId depending on your API contract
            };
            const response = await Profile_api(requestParams);
            console.log("Fetching profile data with params:", requestParams);

            console.log("Profile API Response:", response);

            if (response?.Data?.ResponseCode === 200) {
                const Records = response?.Data?.Records;
                hydrateSessionFromProfile(Records);
                const guid = getGuId();

                if (!guid || guid.trim() === "") {
                    return;
                }
                setIsLoading(false);
                await redirectToHome();

            } else {
                console.error("Profile API failed:", response?.Data?.ErrorMessage);
                setError(response?.Data?.ErrorMessage || "Unable to load profile data.");
                setIsLoading(false);
            }

        } catch (error) {
            console.error("Profile API error:", error);
            setError("Unable to load profile data.");
            setIsLoading(false);
            throw error;
        }
    };

    useEffect(() => {
        if (!email || email.trim() === "") {
            setCompanies([]);
            setLoginMethods([]);
            setSelectedCompany(null);
            setSelectedLoginMethod(null);
            setShowManualLogin(false);
            setIsNewUser(null);
            setShowForgotPasswordMessage(false);
            setForgotPasswordMessage("");
            setError(null);
        }
    }, [email]);

    return (
        <LoginUI
            email={email}
            setEmail={handleEmailChange}
            setPassword={setPassword}
            setFirstName={setFirstName}
            setLastName={setLastName}
            handleSubmit={handleSubmit}
            error={error}
            fieldError={fieldError}
            setFieldError={setFieldError}

            companies={companies}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            loadingCompanies={loadingCompanies}
            loginMethods={loginMethods}
            loadingLoginMethods={loadingLoginMethods}

            showManualLogin={showManualLogin}
            setShowManualLogin={setShowManualLogin}
            isTermsAccepted={isTermsAccepted}
            setIsTermsAccepted={setIsTermsAccepted}
            handleForgotPassword={handleForgotPassword}
            showForgotPasswordMessage={showForgotPasswordMessage}
            forgotPasswordMessage={forgotPasswordMessage}
            handleRedirect={handleRedirect}
            selectedLoginMethod={selectedLoginMethod}
            setSelectedLoginMethod={setSelectedLoginMethod}
            isNewUser={isNewUser}
            isLoading={isLoading}
        />
    );
}

export default LoginEvent;

